module.exports = __webpack_public_path__ + "img/bronze.f26c22e3.jpg";